import request from '@/utils/request'

const http = request()

export const listLog = params => http.post('/system/log/list', params)
